import { Action } from 'redux';
import { FormsInvitationResponse } from './FormsInvitationDtos';

export const FORMS_INVITATION_SET_LOADING = 'FORMS_INVITATION_SET_LOADING';
export const FORMS_INVITATION_SET_DATA = 'FORMS_INVITATION_SET_DATA';
export const FORMS_INVITATION_SET_VIEW = 'FORMS_INVITATION_SET_VIEW';
export const FORMS_INVITATION_UPDATE_ANSWER = 'FORMS_INVITATION_UPDATE_ANSWER';
export const FORMS_INVITATION_SET_RESPONSE_SET_ID = 'FORMS_INVITATION_SET_RESPONSE_SET_ID';
export const FORMS_INVITATION_ERROR = 'FORMS_INVITATION_ERROR';
export const FORMS_INVITATION_SUCCESS = 'FORMS_INVITATION_SUCCESS';
export const FORMS_INVITATION_MARK_NOTIFICATION_SHOWN = 'FORMS_INVITATION_MARK_NOTIFICATION_SHOWN';

interface FormsInvitationSetLoadingAction extends Action<typeof FORMS_INVITATION_SET_LOADING> {
    payload: {
        loading: boolean;
    };
}

interface FormsInvitationSetDataAction extends Action<typeof FORMS_INVITATION_SET_DATA> {
    payload: {
        data: FormsInvitationResponse;
    };
}

interface FormsInvitationSetViewAction extends Action<typeof FORMS_INVITATION_SET_VIEW> {
    payload: {
        view: 'client' | 'pets' | 'success';
    };
}

interface FormsInvitationUpdateAnswerAction extends Action<typeof FORMS_INVITATION_UPDATE_ANSWER> {
    payload: {
        formId: number;
        questionId: number;
        answer: string | string[];
        // Optional subject id (pet id) to scope answers per subject
        subjectId?: number;
    };
}

interface FormsInvitationSetResponseSetIdAction
    extends Action<typeof FORMS_INVITATION_SET_RESPONSE_SET_ID> {
    payload: {
        formId: number;
        responseSetId: number;
        subjectId?: number;
    };
}

interface FormsInvitationErrorAction extends Action<typeof FORMS_INVITATION_ERROR> {
    payload?: {
        code?: number;
        message?: string;
    };
}

interface FormsInvitationSuccessAction extends Action<typeof FORMS_INVITATION_SUCCESS> {}

interface FormsInvitationMarkNotificationShownAction
    extends Action<typeof FORMS_INVITATION_MARK_NOTIFICATION_SHOWN> {
    payload: {
        notificationType: 'addQuestion' | 'addPet';
    };
}

export type FormsInvitationAction =
    | FormsInvitationSetLoadingAction
    | FormsInvitationSetDataAction
    | FormsInvitationSetViewAction
    | FormsInvitationUpdateAnswerAction
    | FormsInvitationSetResponseSetIdAction
    | FormsInvitationErrorAction
    | FormsInvitationSuccessAction
    | FormsInvitationMarkNotificationShownAction;
